import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent = null;

  try {
    // 1. If 'icon' is a component, use it
    if (typeof icon === 'function' || typeof icon === 'object') {
      IconComponent = icon;
    } 
    // 2. If 'icon' is a string (e.g., "Plus"), look it up in FiIcons
    else if (typeof icon === 'string') {
      IconComponent = FiIcons[`Fi${icon}`];
    }
    // 3. Fallback to 'name' prop if provided
    else if (name) {
      IconComponent = FiIcons[`Fi${name}`];
    }
  } catch (e) {
    console.error("Icon resolution error:", e);
  }

  return IconComponent ? (
    React.createElement(IconComponent, props)
  ) : (
    <FiAlertTriangle {...props} />
  );
};

export default SafeIcon;